export default __webpack_public_path__ + "static/media/logo-symbol-gray.ad2b0b0e.svg";